import * as React from 'react';
import Svg, {
  SvgProps,
  Path,
  Defs,
  Stop,
  LinearGradient,
} from 'react-native-svg';

const SvgComponent = (props: SvgProps) => (
  <Svg width={273} height={273} viewBox="0 0 273 273" {...props}>
    <Defs>
      <LinearGradient
        id="grad"
        x1="0"
        y1="136.424"
        x2="272.471"
        y2="136.424"
        gradientUnits="userSpaceOnUse">
        <Stop offset="0" stopColor={props.fill || '#fff'} stopOpacity="0" />
        <Stop offset="1" stopColor={props.fill || '#fff'} stopOpacity="0.5" />
      </LinearGradient>
    </Defs>

    <Path
      d="M232.627 232.627c53.134-53.135 53.134-139.284 0-192.418-53.135-53.135-139.283-53.135-192.418 0-53.135 53.135-53.135 139.283 0 192.418 53.134 53.134 139.283 53.134 192.418 0Z"
      fill="url(#grad)"
    />
  </Svg>
);

export default SvgComponent;
